import styled from 'styled-components';
import { Tooltip as TooltipComponent } from 'react-tooltip';

// setting styles here doesn't work! however having this set up makes it so styles
// in the parent component are honored.  so, i'm leaving it here....
export const StyledTooltip = styled(TooltipComponent)`
	&.__react_component_tooltip {
	}
`;
